<div class="container-fluid p-0 one-page-hero">
  <div class="container one-page-hero__inner">
    <div class="one-page-hero__text">
      <h1 class="pe-5 me-5" [innerHTML]="block.data.heroTitle"></h1>
      <div class="one-page-hero__text-paragraphs" [innerHTML]="block.data.heroBody"></div>
    </div>
    <div class="one-page-hero__boxes">
      <div class="one-page-hero__box">
        <h2>{{ block.data.memberPortalTitle }}</h2>
        <p>{{ block.data.memberPortalText }}</p>
        <a *ngIf="block.data.externalLink" [href]="block.data.linkUrl" class="btn btn-dark btn-blue mt-4"
           target="_blank">{{ block.data.linkText }}
          <span class="btn-icon">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.75 9H14.25" stroke="#131416" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5"/>
              <path d="M9 3.75L14.25 9L9 14.25" stroke="#131416" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5"/>
          </svg>
        </span>
        </a>
        <a *ngIf="!block.data.externalLink" [href]="block.data.linkUrl"
           class="btn btn-dark btn-blue mt-4">{{ block.data.linkText }}
          <span class="btn-icon">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.75 9H14.25" stroke="#131416" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5"/>
              <path d="M9 3.75L14.25 9L9 14.25" stroke="#131416" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5"/>
          </svg>
        </span>
        </a>
      </div>
      <div class="one-page-hero__box">
        <h2>{{ block.data.contactDetailsTitle }}</h2>
        <div class="contact-flex">
          <p *ngIf="block.data.contactDetailsTelephone">
            Telephone:<br>
            <strong>{{ block.data.contactDetailsTelephone }}</strong>
          </p>
          <p *ngIf="block.data.contactDetailsEmailText">
            Email:<br>
            <strong><a
              [href]="'mailto:' + block.data.contactDetailsEmailText">{{ block.data.contactDetailsEmailText }}</a></strong>
          </p>
        </div>
        <div *ngIf="block.data.contactDetailsAddress" class="address-flex"><p>Address:</p>
          <p [innerHtml]="block.data.contactDetailsAddress"></p></div>
      </div>
    </div>
  </div>
  <div class="custom-shape-divider-bottom">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
      <path d="M598.97 114.72L0 0 0 120 1200 120 1200 0 598.97 114.72z" class="shape-fill"></path>
    </svg>
  </div>
</div>
